import React from 'react';
import memoize from 'memoize-one';
import ActionButtons from './ActionButtons';

export default memoize((clickHandler, onlyShow) => [
  {
    name: 'EMPLEADO',
    selector: 'employee_name',
    cell: item => {
      return (
        <div className="d-flex flex-column" role="presentation">
          <span data-tag="allowRowEvents">{item?.full_name}</span>
          <span className="text-muted" data-tag="allowRowEvents">
            {item?.national_identification || item?.nationalIdentification}
          </span>
        </div>
      );
    }
  },
  {
    name: 'CENTRO DE COSTO',
    selector: 'cost_center',
    grow: '1'
  },
  {
    name: 'CONCEPTO',
    grow: '1',
    cell: item => {
      return <span data-tag="allowRowEvents">{item?.balance_name}</span>;
    }
  },
  {
    name: 'MONTO',
    selector: 'parsed_amount',
    grow: '1'
  },
  {
    name: 'ACCIONES',
    selector: 'concept',
    cell: item => {
      if (!onlyShow || !item.balance_type === 'discount') {
        return <ActionButtons clickHandler={clickHandler} isEditing={false} editingId={-1} row={item} />;
      }
      return null;
    }
  }
]);
